import { api } from '../api';

const AUTHORIZATION_VALUE_PREFIX = 'mfasession';

const skip = async ({ authToken }: { authToken: string }) =>
  api.post<void>(
    '/multiFactorAuthentication.skip',
    {},
    {
      Authorization: `${AUTHORIZATION_VALUE_PREFIX} ${authToken}`,
    },
  );

export default skip;
